import React, { useEffect } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import {useHistory} from "react-router-dom";
import { useState } from "react";
import { toggleLoader } from "../../shared/actions/setting";
import axios from "axios";
import {getUserId} from "../../shared/authentication/authentication";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FeatherIcon from 'feather-icons-react';
import EmployeeCard from "../../layouts/employee-card";
import { REPORT_TYPE } from "../../shared/util/enum";

const EmployeeReportHome = () =>{
    const history = useHistory();
    const dispatch = useDispatch();
    const [departmentList, setDepartmentList] = useState([]);
    const [employeeList,setEmployeeList] = useState([]);
    const [machineList, setMachineList] = useState([]);
    const [search, setSearch] = useState('');
    const [department, setDepartment] = useState('');
    const [machine, setMachine] = useState('');
    const [reportType, setReportType] = useState(REPORT_TYPE.DAILY);

    useEffect(() => {
        let corporateID = "60a7794ef812231385f6dce0";
        axios.get(process.env.REACT_APP_HOST + 'user/'
            + getUserId() + '/corporate/'+ corporateID +'/department' )
            .then(res => {
                setDepartmentList(res.data.content);
            }).catch(error => {
                if (error.response && error.response.status === 422) {
                    toast.error(error.response.data.message);
                }
            }
        )

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        axios.get(process.env.REACT_APP_HOST + 'user/'
            + getUserId() + '/machine')
            .then(res => {
                setMachineList(res.data.content);
            }).catch(error => {
                    toast.error(error.response?.data?.message);
            }
        )

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // The backend filters by period, department and machine and calculates each employee's overall performance
    useEffect(() => {
        const params = new URLSearchParams({reportType});
        if (department) {
            params.append('departmentId', department);
        }
        if (machine) {
            params.append('machineId', machine);
        }

        // Ignore responses from requests made with outdated filters
        let isStale = false;
        dispatch(toggleLoader(true));
        axios.get(process.env.REACT_APP_HOST + 'user/'
            + getUserId() + '/employee?' + params.toString())
            .then(res => {
                if (!isStale) {
                    setEmployeeList(res.data.content || []);
                }
            }).catch(error => {
                if (!isStale) {
                    setEmployeeList([]);
                    toast.error(error.response?.data?.message);
                }
            }
        ).finally(() => {
            if (!isStale) {
                dispatch(toggleLoader(false))
            }
        });

        return () => {
            isStale = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reportType, department, machine]);

    const searchTerm = search.trim().toLowerCase();
    const filteredEmployees = searchTerm
        ? employeeList.filter(value => (value.name || '').toLowerCase().includes(searchTerm))
        : employeeList;

    const onClickEmployeeCard = (id) =>{
        history.push(`/employeeReport/${id}`);
    }

    return <div id="listView" className={'list-view full-list-view'}>
        <div className="spy-graph-btn row fs-filters" style={{position:'absolute', right:130, top:0, marginTop:80}}>
            <Form.Control type="text"
              style={{width:"28%"}}
              className="form-control-time-filter"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <select
              className={`form-control form-control-time-filter name-shift h-25 ml-1`}
              name="department"
              onChange={(e) => setDepartment(e.target.value)}
              style={{width:"24%"}}
              value={department}
            >
              <option value="">Department</option>
              {
                departmentList && departmentList.map((item,index) =>{
                    return <option key={index} value={item.id}>{item.name}</option>
                })
              }
            </select>
            <select
              className={`form-control form-control-time-filter name-shift h-25 ml-1`}
              name="machines"
              onChange={(e) => setMachine(e.target.value)}
              style={{width:"22%"}}
              value={machine}
            >
              <option value="">Machines</option>
              {
                machineList && machineList.map((item,index) =>{
                    return <option key={index} value={item.id}>{item.name}</option>
                })
              }
            </select>
            <select
              className={`form-control form-control-time-filter name-shift h-25 ml-1`}
              name="reportType"
              onChange={(e) => setReportType(e.target.value)}
              style={{width:"20%"}}
              value={reportType}
            >
              {
                Object.values(REPORT_TYPE).filter(item => item !== REPORT_TYPE.CUSTOM).map((item,index) => {
                    return <option key={index} value={item}>{item}</option>
                })
              }
            </select>
        </div>
        {
            filteredEmployees.length > 0 ?
                <Container className="m-t-8">
                    <Row xs={1} md={3} className="g-4">
                        {filteredEmployees.map((item, idx) => (
                            <Col key={item.id || idx} className="mt-2" onClick={() => {onClickEmployeeCard(item.id)}}>
                                <EmployeeCard name={item.name} percentage={item.overallPerformance} image={item.imageUrl}/>
                            </Col>
                        ))}
                    </Row>
                </Container>
            :
            <div className={"empty-results w-100"}>
                <FeatherIcon icon="info"/>
                <div className={"empty-results-text"}>There are no employees</div>
            </div>
        }
        <Container style={{height:"10px"}}/>
    </div>
}

export default EmployeeReportHome;
